import { Injectable } from '@angular/core';

@Injectable()
export class ObservationConstantsService {

  constructor() { }

  // Module specific constants
  public static ObservationCardModuleConst = {
    observationFor: 'self',
    observationOnBehalfEmployee: 'onbehalfemp',
    ObservationOnBehalfContractor: 'onbehalfcontractor',
    SubmitDate: 'Submit Date',
    DESC: 'DESC',
    ASC: 'ASC',
    ObservationDate: 'Observation Date',
    Conversation: 'Conversation',
    Safe: 'Safe',
    ActBehaviour: 'Act/ Behaviour',
    Observation: 'Observation',
    Unsafe: 'Unsafe',
    ConditionConsequence: 'Condition/ Consequence',
    ObservationDashboard: 'HSE advisor dashboard',
    HseDashboard: 'HSE Dashboard',
    SourceId: 'Source Id',
    HealthHazard: 'Health Hazard',
    ExplodingBomb: 'ExplodingBomb',
    Flame: 'Flame',
    ExclamationMark: 'Exclamation Mark',
    GasCylinder: 'Gas Cylinder',
    Oxidizer: 'Oxidizer',
    HSEAdvisor: 'HSEAdvisor',
    LoggedInUser: 'loggedInUser',
    Other: 'Other',
    TakeAction: 'Take Action',
    Reports: 'Reports',
    ViewClosureDetails: 'View Closure Details',
    NA: 'NA',
    OBS: 'OBS',
    BackOfficeDashboard: 'Back-office Dashboard',
    INC: 'INC',
    Location: 'Location',
    ObservationType: 'ObservationType',
    Status: 'Status',
    MakeObservation: 'Make Observation',
    Inspection: 'Inspection'
  };

  // Company Constants
  public static CompanyConst = {
    QAMP: 'QAMP'
  };

  // Status Constants
  public static Status = {
    New: 'New',
    Closed: 'Closed',
    Deleted: 'Deleted',
    Assigned: 'Assigned',
    Acknowledged: 'Acknowledged',
    ActionsAdded: 'ActionsAdded',
    Cancelled: 'Cancelled',
    All: 'All',
    Restate: 'Restate',
    Draft: 'Draft'
  };

  // URL constant
  public static ObservationCardURL = {
    InsertObservationData: 'api/hse/observationCard/insertObservationData',
    GetLocationDetails: 'api/hse/observationCard/getLocationDetails',
    GetCompanyDetails: 'api/hse/observationCard/getCompanyDetails',
    GetObservationData: 'api/hse/observationCard/getObservationcardData',
    GetProcess: 'api/common/master/getProcess',
    GetStatusByProcessId: 'api/common/get/statusByProcessId',
    GetUserTypes: 'api/common/get/userTypes',
    GetUsersOnSearch: 'api/common/get/usersOnSearch',
    GetUserDetails: 'api/hse/observationCard/getUserDetailsByUserId',
    GetObservationRequest: 'api/hse/observationCard/GetObservationRequest',
    CancelObservationRequest: 'api/hse/observationCard/cancelobservationrequest',
    ReStateObservationrequest: 'api/hse/observationCard/ReStateObservationrequest',
    UserLogInDetails: 'api/hse/observationCard/saveUserLoginDetails',
    CloseObservationRequest: 'api/hse/observationCard/CloseObservationRequest',
    UpdateObservationData: 'api/hse/observationCard/updateObservationData',
    InsertActonDetails: 'api/hse/actionTracker/insertActionData',
    Cancelactiondetails: 'api/hse/actionTracker/cancelactiondetails',
    Deleteactiondetails: 'api/hse/actionTracker/deleteactiondetails',
    GetObservationRequestForHSEAdvisor: 'api/hse/observationCard/GetObservationRequestForHSEAdvisor',
    ExportToExcelObservationRequestForHSEAdvisor: 'api/hse/observationCard/ExportToExcelObservationRequestForHSEAdvisor',
    GetObservationForHSEAdvisor: 'api/hse/observationCard/GetObservationRequestForDelete',
    DeleteObservationByHSEAdvisor: 'api/hse/observationCard/DeleteObservationByHSEAdvisor',
    GetObservationTypeByCompanyId: 'api/hse/observationCard/getobservationtypebycompanyid',
    GetHazardTypeByCompanyId: 'api/hse/configuration/gethazarddetails',
    GetObservationRequestsForDashboard: 'api/hse/observationCard/getpastobservationrequestsfordashboard',
    AcknowledgeObservationRequest: 'api/hse/observationCard/acknowledgeobservationrequest',
    GetObservationRequestByObservationId: 'api/hse/observationCard/getobservationrequestbyobservationid',
    GetActionsByObservationId: 'api/hse/actionTracker/GetActionDetailsByObservationId',
    GetTempObservationRequestForBackOffice: 'api/hse/observationCard/gettempobservationrequestforbackoffice',
    GetUserDetailsByTempObservationId: 'api/hse/observationCard/getuserdetailsbytempobservationid',
    DeleteObservationRequestByTempObsId: 'api/hse/observationCard/deleteobservationrequestbytempObsId',
    UpdateTempObservationRequestForBackOffice: 'api/hse/observationCard/updatetempobservationrequestforbackoffice',
    GetObservationStatusReport: 'api/report/get/observationStatusReport',
    GetAllActionByObservationId: 'api/hse/actionTracker/GetAllActionByObservationId',
    ExportToExcel: 'api/hse/observation/ExportToExcel',
    UpdateHazardType: 'api/hse/observationCard/updateHazardType',
    InsertActionAssignedByHseAdvisor: 'api/hse/observationCard/insertActionAssignedByHseAdvisor',
    UpdateActionAssignedByHseAdvisor: 'api/hse/observationCard/updateActionAssignedByHseAdvisor',
    DownloadPDF: 'api/hse/get/downloadpdf',
    SavePDF: 'api/hse/savepdf',
    SubmitSpecificationData: 'api/hse/observationCard/submitSpecificationData',
    DownloadZIP: 'api/hse/get/downloadzip'
  };

  // Routing URL
  public static RoutingURLConstant = {
    MyObservationURL: '/observation/past-observations-dashboard',
    ObservationDashboardURL: '/observation/observation-card-overview',
    ObservationCardURL: '/observation/make-observation/new'
  };

  public static RouteName = {
    BackofficeDashboard: "Back-office Overview"
  }

  // Side bar routesURL and routeName of Observation
  public static ObservationNavigation = {
    Routes: [
      {
        routeName: 'Home',
        routeURL: '../../home',
        isClickable: true
      },
      {
        routeName: 'Make Observation',
        routeURL: '/observation/make-observation/new',
        isClickable: true
      },
      {
        routeName: 'Observations Overview',
        routeURL: '/observation/observation-card-overview',
        isClickable: true
      },
      // {
      //   routeName: 'Back-office Overview',
      //   routeURL: '/observation/back-office-overview'
      // }
    ],
    InnerRoutes: [
      {
        routeName: 'Home',
        routeURL: '../../../home',
        isClickable: true
      },
      {
        routeName: 'Make Observation',
        routeURL: '/observation/make-observation/new',
        isClickable: true
      },
      {
        routeName: 'Observations Overview',
        routeURL: '/observation/observation-card-overview',
        isClickable: true
      },
      // {
      //   routeName: 'Back-office Overview',
      //   routeURL: '/observation/back-office-overview'
      // }
    ],
    ReportRoutes: [
      {
        routeName: 'observation-category-trend-report',
        routeURL: '/report/observation-category-trend-report',
        isClickable: true
      },
      {
        routeName: 'observation-requests-trend-report',
        routeURL: '/report/observation-requests-trend-report',
        isClickable: true
      },
      {
        routeName: 'observation-type-trend-report',
        routeURL: '/report/observation-type-trend-report',
        isClickable: true
      },
      {
        routeName: 'action-trend-report',
        routeURL: '/report/action-trend-report',
        isClickable: true
      },
      {
        routeName: 'observation-status-report',
        routeURL: '/report/observation-status-report',
        isClickable: true
      }
    ]
  };
  // Chcek Observation type message
  public static ObservationType = {
    didYouSee: 'didYouSee',
    didYouDo: 'didYouDo',
    improvedType: 'improvedType'
  };

  // Event on Click
  public static EventType = {
    mouseenter: 'mouseenter',
  };

  // Observation Status
  public static ObservationStatus = {
    New: 'New',
    Acknowledged: 'Acknowledged',
    Cancelled: 'Cancelled',
    Closed: 'Closed',
    Deleted: 'Deleted',
    Pending: 'Pending',
    Submitted: 'Submitted',
    All: 'All',
    Restate: 'Restate'
  };

  // request for
  public static RequestFor = {
    Self: 'Self',
    OnBehalf: 'On Behalf',
    Contractor: 'Contractor'
  };

  // Success, confiramtion and exceptional message
  public static Message = {
    ObservationCancelledSuccess: 'Observation Cancelled successfully',
    ObservationCancelledConfirmation: 'Are you sure want to cancel this observation Card?',
    ObservationRestateSuccess: 'Observation restate successfully',
    ObservationRestateConfirmation: 'Are you sure want to restate this observation Card?',
    BackOfficeRequestDeleted: 'Request deleted successfully',
    BackOfficeConfirmationMessage: 'Do you really want to delete this request?'
  };

  // Comment section constants, used for action comment configuration
  public static AcitonCommentConstants = {
    HSEAdviserToActionOwner: 'HSE Adviser added action and assigned it to Action owner :',
    HSEAdviserToActionParty: 'HSE Adviser added action and assigned it to Action Party :',
    HSEAdviserToActionVerifier: 'HSE Adviser added action and assigned it to Action Verifier :',
    HSEAdviserCloseAction: 'HSE Adviser has closed action.',
    HSEAdviserChangeActionOwner: 'HSE Adviser has changed the Action owner to :',
    HSEAdviserChangeActionParty: 'HSE Adviser has changed the Action party to :',
    HSEAdviserChangeActionVerifier: 'HSE Adviser has changed the Action verifier to :',
    ActionOwner: 'Action owner has updated the action details. Action owner :',
    ActionParty: 'Action party has updated the action details. Action party :',
    ActionVerifier: 'Action verifier has updated the action details. Action verifier :',
    StatusFrom: 'Action status changed from :',
    StatusTo: 'Action status changed to :',
    ActionDeleted: 'Action deleted successfully'
  };

  public static Tooltip = {
    TakeAction: 'Take Action',
    ViewDetails: 'View Details',
    ViewAction: 'View Observation'

  };

  public static StatusList = {
    StatusId: 1000,
    StatusName: 'Assigned',
    checked: false
  };

  // Set Back office URL
  public static SubRouting = {
    Backofficedashboard: 'back-office-overview'
  };

  // Back office drop down delete constant
  public static ReasonForDeletion = [
    { label: 'Blur image', value: 'Blur image' },
    { label: 'Irrelevant image', value: 'Irrelevant image' }
  ];
  public static ToolTip = {
    TakeAction: 'Take Action',
    ViewAction: 'View Observation',
  };
  public static MultiSelectStatus = [
    { label: 'Submitted', value: 'Submitted' }
  ];
}
